
export default {
	state: {
		type: null,
		text: null
	},

	mutations: {

		info (state, text) {
			state.type = 'info';
			state.text = text;
		},

		success (state, text) {
			state.type = 'success';
			state.text = text;
		},

		warning (state, text) {
			state.type = 'warning';
			state.text = text;
		},

		error (state, text) {
			state.type = 'danger';
			state.text = text;
		},

		clear (state) {
			state.type = null;
			state.text = null;
		}

	},

	actions: {

		info ({commit}, [text, timeout = 5000]) {
			commit('info', text);
			setTimeout( () => commit('clear'), timeout );
		},

		success ({commit}, [text, timeout = 5000]) {
			commit('success', text);
			setTimeout( () => commit('clear'), timeout );
		},

		warning ({commit}, [text, timeout = 5000]) {
			commit('warning', text);
			setTimeout( () => commit('clear'), timeout );
		},

		error ({commit}, [text, timeout = 10000]) {
			commit('error', text);
			setTimeout( () => commit('clear'), timeout );
		},

	},

	namespaced: true
};



// WEBPACK FOOTER //
// ./src/store/modules/alert.js